var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Loader, Message } from "sb-resp-ui";
// external components
import * as CMP from "./components";
var RacingFutureEvents = /** @class */ (function (_super) {
    __extends(RacingFutureEvents, _super);
    function RacingFutureEvents(props) {
        var _this = _super.call(this, props) || this;
        _this.dict = _this.props.dict;
        _this.state = {
            dataProvider: _this.props.dataProvider,
        };
        return _this;
    }
    /* istanbul ignore next */
    RacingFutureEvents.prototype.renderRows = function (rows) {
        var _this = this;
        return rows.map(function (x) {
            return (React.createElement(CMP.Row, { key: x.id },
                React.createElement(CMP.Cta, { url: _this.state.dataProvider.getFutureEventUrl(x.urlCode, x.leagueId), handler: _this.state.dataProvider.getFutureEventHandler(x) },
                    React.createElement(CMP.League, { date: x.formattedDate, time: x.formattedTime, label: x.eventName }),
                    React.createElement(CMP.Icon, null))));
        });
    };
    /* istanbul ignore next */
    RacingFutureEvents.prototype.renderLoader = function () {
        return (React.createElement("div", { className: "rj-racing-future-events__loader" },
            React.createElement(Loader, null)));
    };
    /* istanbul ignore next */
    RacingFutureEvents.prototype.renderMessage = function () {
        return React.createElement(Message, { text: "test message" });
    };
    /* istanbul ignore next */
    RacingFutureEvents.prototype.render = function () {
        var l = this.state.dataProvider.getAntepostEvents.length;
        return (React.createElement("div", { className: "rj-racing-future-events" },
            !l && this.renderLoader(),
            false && this.renderMessage(),
            (l > 0) && this.renderRows(this.state.dataProvider.getAntepostEvents)));
    };
    RacingFutureEvents = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], RacingFutureEvents);
    return RacingFutureEvents;
}(React.Component));
export { RacingFutureEvents };
//# sourceMappingURL=RacingFutureEvents.js.map